// extracted by mini-css-extract-plugin
module.exports = {"bpLarge":"992px","colorTechnologyStart":"#f58529","colorTechnologyEnd":"#0ca3a3","pageYOffset":"450px","block":"ColoredSVG-module--block--zRwDy"};